import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Button from './Button';

interface ModalProps {
  children: React.ReactNode;
  actionBar?: React.ReactNode;
  isOpen: boolean;
  hideCancelButton?: boolean,
  onAfterOpen?: () => void;
  onRequestClose: () => void;
  card?: boolean;
  overflowVisible?: boolean;
}

Modal.setAppElement('#root');

const CustomModal: React.FC<ModalProps> = ({
  children,
  actionBar,
  isOpen,
  hideCancelButton,
  onAfterOpen,
  onRequestClose,
  card,
  overflowVisible = false,
}) => {
  const [actionBarContent, setActionBarContent] = useState(actionBar);

  useEffect(() => {
    setActionBarContent(actionBar);
  }, [actionBar]);

  // Lock scroll without jumping to top when the modal opens
  useEffect(() => {
    const { body } = document;
    const { scrollY, pageYOffset } = window;
    if (isOpen) {
      const currentY = typeof scrollY === 'number' ? scrollY : (pageYOffset || 0);
      body.style.position = 'fixed';
      body.style.top = `-${currentY}px`;
      body.style.width = '100%';
      body.style.overflowY = 'scroll';
    } else {
      const { top } = body.style;
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.overflowY = '';
      const y = top ? -parseInt(top, 10) : 0;
      window.scrollTo(0, y);
    }
  }, [isOpen]);

  const onClose = () => {
    setActionBarContent(null);
    onRequestClose();
  };

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxHeight: card ? '100svh' : '90vh',
      maxWidth: '80vw',
      overflow: overflowVisible ? 'visible' : 'hidden',
      padding: '0px',
      border: '1px solid rgb(var(--color-border-secondary))',
      borderRadius: '32px',
      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'rgb(var(--color-surface-base))',
      display: 'flex',
      flexDirection: 'column' as const,
    },
    overlay: {
      zIndex: 1300,
      backgroundColor: 'rgb(var(--color-surface-base) / 0.5)',
      backdropFilter: 'blur(8px)',
      '-webkit-backdrop-filter': 'blur(4px)',
    },
  };

  return (
    <Modal
      isOpen={isOpen}
      onAfterOpen={onAfterOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel="Example Modal"
    >
      <div
        style={{
          overflow: overflowVisible ? 'visible' : 'auto',
          padding: card ? '0px' : '24px',
        }}
      >
        {children}
        <div className="flex flex-col justify-center items-center">
          {actionBarContent}
          {!hideCancelButton && <Button variant="secondary" onClick={onClose} className='text-center w-full mx-5 mt-2'>
            Cancelar
          </Button>}
        </div>
      </div>
    </Modal>
  );
};

export default CustomModal;
